import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import rrLogo from "../../images/logo.png";
import ig from "../../images/ig.png";

import "../layout/layout.css";

const Layout = (props) => {
  const { children } = props;
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const menuBar = document.querySelector(".MenuBar");
      if (window.scrollY > 50) {
        menuBar.classList.add("collapsed");
      } else {
        menuBar.classList.remove("collapsed");
      }
    };

    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMobileMenuOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <div className="Layout">
      <div className="MenuBar">
        <div className="MenuBarLeft">
          <Link to="/">
            <img className="logo" src={rrLogo}></img>
          </Link>
        </div>
        <div className="MenuBarRight">
          <div className="MenuBarRightContent">
            <Link to="/" onClick={() => window.scroll(0, 0)}>
              Home
            </Link>
            <Link to="/leadership" onClick={() => window.scroll(0, 0)}>
              Leadership
            </Link>
            <Link to="/carriers" onClick={() => window.scroll(0, 0)}>
              Our Carriers
            </Link>
            <Link to="/contact" onClick={() => window.scroll(0, 0)}>
              Contact Us
            </Link>
          </div>
          <div className="mobile-menu-icon" onClick={toggleMobileMenu}>
            &#9776;
          </div>
        </div>
        {isMobileMenuOpen && (
          <div className="MobileMenu" ref={menuRef}>
            <Link
              to="/"
              onClick={() => {
                toggleMobileMenu();
                window.scroll(0, 0);
              }}
            >
              Home
            </Link>
            <Link
              to="/leadership"
              onClick={() => {
                toggleMobileMenu();
                window.scroll(0, 0);
              }}
            >
              Leadership
            </Link>
            <Link
              to="/carriers"
              onClick={() => {
                toggleMobileMenu();
                window.scroll(0, 0);
              }}
            >
              Our Carriers
            </Link>
            <Link
              to="/contact"
              onClick={() => {
                toggleMobileMenu();
                window.scroll(0, 0);
              }}
            >
              Contact Us
            </Link>
            <Link
              id="mobile-apply"
              to="/contact"
              onClick={() => window.scroll(0, 0)}
            >
              REQUEST AND INTERVIEW
            </Link>
            <div className="menuIconContainer">
              <a id="ig" href="https://www.instagram.com/reszkonation/">
                <img className="ig" src={ig}></img>
              </a>
            </div>
          </div>
        )}
      </div>

      <div>{children}</div>

      <div className="recruitment-bar">
        <div className="recruitment-content">
          <h1>The Next Chapter Starts Here</h1>
          <p>
            Reszko Nation is cultivating leaders across the country through
            structure, mentorship, and opportunity.<br></br> If you are ready to
            elevate your standards and your future, we invite you to begin the
            conversation.
          </p>
        </div>
        <button className="recruitment-button">
          <p>Request An Interview</p>
        </button>
      </div>

      <div className="Footer">
        <div className="FooterContent">
          <div className="FooterTop">
            <hr></hr>
          </div>
          <div className="FooterMiddle">
            <Link to="/" onClick={() => window.scroll(0, 0)}>
              Home
            </Link>
            <Link to="/leadership" onClick={() => window.scroll(0, 0)}>
              Leadership
            </Link>
            <Link to="/carriers" onClick={() => window.scroll(0, 0)}>
              Carriers
            </Link>
            <Link to="/contact" onClick={() => window.scroll(0, 0)}>
              Contact
            </Link>
          </div>
          <div className="FooterBottom">
            <div className="FooterSocial">
              <a href="https://www.facebook.com/MedaHealth/"></a>
              <a href="https://www.instagram.com/meda.health/"></a>
            </div>
          </div>
        </div>
        <div className="copyBar">
          <a>Copyright © 2026 Reszko Nation. All Right Reserved. </a>
          <a> Terms & Conditions</a>
          <a>Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};

export default Layout;
